module.exports = __webpack_public_path__ + "static/media/ajax-Loader.cdc7796a.gif";